import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { NoteProps } from './types';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn, getColorway, getYMarginsSlim } from 'utils/styles';

const Note = ({ sys, color, headline, copy, margins }: NoteProps) => {
  return (
    <section className={cn(getColorway(color), getYMarginsSlim(margins), 'rounded-[20px]')} data-testid="note">
      <div className="px-6 md:px-14">
        <div className="border border-(--keyline-color) rounded-lg p-8 sm:py-12 sm:px-16 space-y-4">
          <div
            {...liveUpdateAttrs(sys?.id, 'headline')}
            data-testid="noteHeadline"
            className="font-sans text-2xl font-semibold">
            <RichTextHeadline headline={headline} />
          </div>
          <div {...liveUpdateAttrs(sys?.id, 'copy')} data-testid="noteCopy" className="font-serif text-body-serif">
            <RichTextCopy copy={copy} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Note;
